(function () {

  var FIELDS = {
    title : 'textarea[name="Titre affiche"]',
    date  : 'textarea[id="textarea-2"]',
    lieu  : 'textarea[id="textarea-3"]',
  };

  var DEFAULTS = {
    title : 'Votre titre / prénom(s)',
    date  : 'Votre date - votre heure',
    lieu  : 'Votre lieu - pays / région',
  };

  function update() {
    var fields = ['title', 'date', 'lieu'];
    var ids = ['pv-title', 'pv-date', 'pv-lieu'];
    for (var i = 0; i < fields.length; i++) {
      var input = document.querySelector(FIELDS[fields[i]]);
      var display = document.getElementById(ids[i]);
      if (display) {
        display.textContent = (input && input.value.trim()) ? input.value.trim() : DEFAULTS[fields[i]];
      }
      if (input && !input._pv) {
        input.addEventListener('input', update);
        input._pv = true;
      }
    }
    if (typeof pvFitAll === 'function') pvFitAll();
  }

  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    update();
    if (attempts >= 20) clearInterval(interval);
  }, 500);

})();
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (form.querySelector('[name="id"]')) {
    var fontInput = document.getElementById('pv-font-input');
    if (fontInput) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = "properties[Police d'écriture]";
      hidden.value = fontInput.value;
      form.appendChild(hidden);
    }
  }
}, true);
document.addEventListener('DOMContentLoaded', function () {
  const stickyEl = document.querySelector('.product__media-wrapper');
  if (!stickyEl || !window.visualViewport) return;

  const initialHeight = window.visualViewport.height;

  function handleViewportResize() {
    const vv = window.visualViewport;
    const keyboardLikelyOpen = vv.height < initialHeight * 0.75;
    const activeIsFormField = document.activeElement.matches(
      '.gpo-input, .gpo-textarea, input, textarea'
    );

    if (keyboardLikelyOpen && activeIsFormField) {
      stickyEl.style.setProperty('max-height', '35vh', 'important');
      stickyEl.style.setProperty('overflow', 'hidden', 'important');
    } else {
      stickyEl.style.removeProperty('max-height');
      stickyEl.style.removeProperty('overflow');
    }
  }

  window.visualViewport.addEventListener('resize', handleViewportResize);
});
/* === Message cadeau : affiche la zone de texte si "C'est un cadeau" est coché === */
(function () {
  var essais = 0;
  var attente = setInterval(function () {
    essais++;
    var caseCadeau = document.querySelector('input[type="checkbox"][data-field-name*="cadeau"]');
    var zone = document.querySelector('textarea[name^="Message cadeau"]');
    var bloc = zone && zone.closest('.gpo-element');
    if (caseCadeau && bloc) {
      clearInterval(attente);
      function maj() {
        bloc.style.display = caseCadeau.checked ? '' : 'none';
        if (!caseCadeau.checked) zone.value = '';
      }
      caseCadeau.addEventListener('change', maj);
      maj();
    }
    if (essais > 40) clearInterval(attente);
  }, 250);
})();